import { CSSProperties, ReactNode } from "react";
import { TableCell, TableRow } from "@mui/material";
import Table from "./Table";
import "./OrderPreviewTableLayout.css";

export interface OrderPreviewColumn {
  key: string;
  label: ReactNode;
  subtitle?: string;
  width: number;
}

export const previewNumber = (value: number | string | null | undefined) =>
  value == null || value === ""
    ? "—"
    : Number.isFinite(Number(value))
      ? Number(value).toLocaleString("en-US", { maximumFractionDigits: 10 })
      : String(value);

export const PreviewNumber = ({ value, suffix = "" }: {
  value: number | string | null | undefined;
  suffix?: string;
}) => <span dir="ltr" className="order-preview-number">{previewNumber(value)}{suffix}</span>;

export const PreviewAccount = ({ name, sheet, row, canSend = true }: {
  name: string;
  sheet?: string;
  row?: number;
  canSend?: boolean;
}) => <>
  <div className="font-medium">{name}</div>
  {sheet ? <div className="order-preview-secondary">شیت {sheet} · ردیف {row ?? "—"}</div> : null}
  {!canSend ? <div className="order-preview-status">غیرقابل ارسال</div> : null}
</>;

const OrderPreviewTableLayout = ({ title, count, columns, children, minWidth = 1000 }: {
  title: string;
  count: number;
  columns: OrderPreviewColumn[];
  children: JSX.Element;
  minWidth?: number;
}) => {
  const totalWidth = columns.reduce((sum, column) => sum + column.width, 0);
  return <div dir="rtl" className="order-preview-table" style={{ "--preview-table-min-width": `${minWidth}px` } as CSSProperties}>
    <div className="order-preview-table-scroll" role="region" aria-label={title} tabIndex={0}>
      <Table
        header={<>{columns.map((column) => <TableCell key={column.key} scope="col" style={{ width: `${column.width / totalWidth * 100}%` }}>
          {column.label}
          {column.subtitle ? <span className="order-preview-header-subtitle">{column.subtitle}</span> : null}
        </TableCell>)}</>}
        body={count ? children : <TableRow><TableCell colSpan={columns.length}>سفارشی برای پیش‌نمایش وجود ندارد.</TableCell></TableRow>}
      />
    </div>
  </div>;
};

export default OrderPreviewTableLayout;
